var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "120px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "仪表类型名称", prop: "meterName" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                model: {
                  value: _vm.childData.meterName,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "meterName", $$v)
                  },
                  expression: "childData.meterName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: _vm.$t("table.meterUnint"), prop: "meterUnint" }
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.childData.meterUnint,
                    callback: function($$v) {
                      _vm.$set(_vm.childData, "meterUnint", $$v)
                    },
                    expression: "childData.meterUnint"
                  }
                },
                _vm._l(_vm.meterUnintOptions, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.remark") } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: {
                  maxlength: "50",
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 6 }
                },
                model: {
                  value: _vm.childData.meterRemark,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "meterRemark", $$v)
                  },
                  expression: "childData.meterRemark"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }